<script>
    import {
        CardLayout,
        Loader,
        DateInput
    } from "../../../../Components/Common/index.svelte";
    import { onMount } from "svelte";
    import CreateSurgeonModal from "../CreateSurgeonModal.svelte";
    import Select from "svelte-select/Select.svelte";
    import { apiMethods } from "../../../../Services/index.svelte";
    import { getTitle, showError } from "../../../../Utils/utilFunctions.svelte";
    import { cacheAccountPrePopulateSearchOptions } from "../../../../Utils/utilCache.svelte";
    import {
        user,
        loggedInDoctorDetail,
        prePopulateAccountOptions,
    } from "../../../../stores";

    import {
        addErrorInput,
        removeErrorInput,
    } from "../../../PatientEncounter/helpers/encounterUtils.svelte";
    import { encounterBillingType, defaultState  } from "../../../../Utils/utilEnums.svelte";

    export let 
        commonDetails,
        overrideValidation,
        onDoctorChangeCallback;

    let errInputs = []; //used for validation

    let 
        isLoadingAccountDoctors = false,
        hasSuggestedAccountDoctorsFetched = false,
        isLoadingSuggestedAccountDoctors = false,
        suggestedAccountDoctors = [];

    let hasSuggestedHospitalsFetched = false,
        isLoadingSuggestedHospitals = false,
        suggestedHospitals = [];

    let surgeonOptions = [],
        accountDoctors = [],
        preOpQuestionnaireOptions = [],
        preOpInstructionOptions = [],
        hospitalOptions = [],
        isLoadingDoctorDetails = false,
        createSurgeonFilters = { state: defaultState };
    
    let isCreateNewSurgeonModalOpen = false;
    
    $: isAdmin =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: _syncSurgeonOptions(accountDoctors, suggestedAccountDoctors);
    
    const btnOptions = [
    ];

    onMount(() => {
       /*  loadPreOpQuestionnaires();

        loadPreOpInstructions(); */
    });

    export const checkValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    const _updateInvalidFieldsStyle = () => {
        //check schedule date
        if (!commonDetails.scheduledDate)
            errInputs = addErrorInput("scheduledDateField", errInputs, "Schedule date");
        else errInputs = removeErrorInput("scheduledDateField", errInputs);

        //check doctor select
        if(!commonDetails.selectedDoctor){
            errInputs = addErrorInput("doctorSelect", errInputs, "Doctor");
        } else {
            errInputs = removeErrorInput("doctorSelect", errInputs);
            //doctor is selected, check provider, surgeon, hospital
            if(!commonDetails.selectedDoctorProvider){
                errInputs = addErrorInput("doctorProviderSelect", errInputs, "Doctor provider");
            } else {
                errInputs = removeErrorInput("doctorProviderSelect", errInputs);
            }

            if(!commonDetails.selectedHospital && !overrideValidation){
                errInputs = addErrorInput("hospitalSelect", errInputs, "Doctor");
            } else {
                errInputs = removeErrorInput("hospitalSelect", errInputs);
            }

            if(!commonDetails.selectedSurgeon && !overrideValidation){
                errInputs = addErrorInput("surgeonSelect", errInputs, "Doctor");
            } else {
                errInputs = removeErrorInput("surgeonSelect", errInputs);
            }

        }
    };

    const loadPreOpQuestionnaires = async () => {
        //load preopquestionnaires by selected doctor
        const searchParams = {
            "filter[doctorId]": commonDetails.selectedDoctor.id
        };
        await apiMethods.getMethod
            .getPreOpQuestionnaires(0, 999999, searchParams)
            .then((res) => {
                if (!res || res.error) {
                    showError(
                        res.error ??
                            "Failed to load Pre-Op Questionnaire for selected doctor",
                    );
                } else preOpQuestionnaireOptions = [...res.results];
            })
    };

    const loadPreOpInstructions = async () => {
        //load preopinstructions by selected doctor
        const searchParams = {
            "filter[doctorId]": commonDetails.selectedDoctor.id
        };
        await apiMethods.getMethod
            .getPreOpInstructions(0, 999999, searchParams)
            .then((res) => {
                if (!res || res.error) {
                    showError(
                        res.error ??
                            "Failed to load Pre-Op Instructions for selected doctor",
                    );
                } else preOpInstructionOptions = [...res.results];
            })
       
    };

    const goToPreviewQuestionnaire = () => {
        if (commonDetails.selectedPreOpQuestionnaire) {
            window.open(commonDetails.selectedPreOpQuestionnaire.url, "_blank");
        }
    };

    const _syncSurgeonOptions = ( 
        accountDoctors = [],
        suggestedSurgeons = [],
    ) => {
        surgeonOptions = [];

        let uniqueAccountDoctors = [
            ...new Map(accountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        if (!suggestedSurgeons)
            uniqueAccountDoctors.map((doctor) => {
                surgeonOptions.push({
                    ...doctor,
                    displayLabel: getOptionLabelForSurgeon(doctor),
                    matchingId: `${doctor.id}${doctor.state}`,
                });
            });
        else {
            const suggestedSurgeonUniqueIds = [];
            const len = Math.min(suggestedSurgeons.length, 5);

            for (let i = 0; i < len; i++) {
                const surgeon = suggestedSurgeons[i];

                surgeonOptions.push({
                    ...surgeon,
                    groupName: "Suggested surgeons",
                    displayLabel: getOptionLabelForSurgeon(surgeon),
                    matchingId: `${surgeon.id}${surgeon.state}`,
                });

                suggestedSurgeonUniqueIds.push(surgeon.providerUniqueId);
            }

            uniqueAccountDoctors.map((surgeon) => {
                if (
                    !suggestedSurgeonUniqueIds.includes(
                        surgeon.providerUniqueId.toString(),
                    )
                )
                    surgeonOptions.push({
                        ...surgeon,
                        groupName: "Other Surgeons",
                        displayLabel: getOptionLabelForSurgeon(surgeon),
                        matchingId: `${surgeon.id}${surgeon.state}`,
                    });
            });
        }
    };

    const clearCurrentSurgeon = () => {
        commonDetails.selectedSurgeon = null;

        errInputs = removeErrorInput(
            "surgeonSelect",
            errInputs,
            "Surgeon/Referrer",
        );
    };

    const loadAccountDoctors = async () => {
        isLoadingAccountDoctors = true;

        const obj = {
            "filter[doctorId]": commonDetails.selectedDoctor.id,
        };

        await apiMethods.getMethod
            .getAccountDoctors(0, 999999, obj)
            .then((res) => {
                if (res.results) {
                    accountDoctors = [...res.results];
                }
            });

        isLoadingAccountDoctors = false;
    };

    const loadSuggestedAccountDoctors = async () => {
        if (suggestedAccountDoctors.length || hasSuggestedAccountDoctorsFetched)
            return;

        const doctorID = commonDetails.selectedDoctor.id;

        if (!doctorID) return;

        isLoadingSuggestedAccountDoctors = true;

        await apiMethods.getMethod.getSuggestedSurgeon(doctorID).then((res) => {
            if (res.results) suggestedAccountDoctors = [...res.results];
        });

        //filter surgeons and take only once by unique id
        suggestedAccountDoctors = [
            ...new Map(suggestedAccountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        if (suggestedAccountDoctors.length > 5)
            suggestedAccountDoctors = suggestedAccountDoctors.slice(0, 5);

        hasSuggestedAccountDoctorsFetched = true;

        isLoadingSuggestedAccountDoctors = false;
    };

    const getOptionLabelForSurgeon = ({
        firstName,
        lastName,
        title,
        speciality,
        state,
    }) =>
        `${getTitle(title)} ${firstName} ${lastName} (${speciality})`;

    const onFocusSurgeonSelector = () => {
        errInputs = removeErrorInput("surgeonSelect", errInputs);

        loadSuggestedAccountDoctors();
        loadAccountDoctors();
    };

    const loadSuggestedHospitals = async () => {
        if (
            suggestedHospitals.length ||
            hasSuggestedHospitalsFetched ||
            isLoadingSuggestedHospitals
        )
            return;

        const doctorID = $loggedInDoctorDetail.id;

        if (!doctorID) return;

        isLoadingSuggestedHospitals = true;

        await apiMethods.getMethod
            .getSuggestedHospital(doctorID)
            .then((res) => {
                if (res.results) {
                    suggestedHospitals = [...res.results];

                    const suggestedOptions = [];

                    suggestedHospitals.map((hospital) => {
                        suggestedOptions.push({
                            ...hospital,
                            groupName: "Suggested Hospitals",
                        });
                    });

                    hospitalOptions = [...suggestedOptions];
                }
            });

        hasSuggestedHospitalsFetched = true;

        isLoadingSuggestedHospitals = false;
    };

    const loadHospitals = async (searchText) => {
        const res = searchText
            ? await apiMethods.getMethod.getHospitals(0, 999999, {
                  search: searchText,
              })
            : await Promise.resolve([]);

        return _handleSearchHospitals(
            res.results?.length > 0 ? res.results : [],
        );
    };

    const clearCurrentHospital = () => {
        commonDetails.selectedHospital = null;

        errInputs = removeErrorInput("hospitalSelect", errInputs, "Hospital");

        loadHospitals();
    };

    const handleHospitalChange = () => {
        errInputs = removeErrorInput("hospitalSelect", errInputs);
    };

    const onFocusHospitalSelector = async () => {
        errInputs = removeErrorInput("hospitalSelect", errInputs, "Hospital");

        await loadSuggestedHospitals();
    };

    const _handleSearchHospitals = (res = []) => {
        hospitalOptions = [];

        if (!res.length && !suggestedHospitals.length) return [];

        const suggestedOptions = [];

        if (res.length) {
            hospitalOptions = [...res];
            return [...res];
        }

        if (!suggestedHospitals.length) return [];

        suggestedHospitals.map((hospital) => {
            suggestedOptions.push({
                ...hospital,
                groupName: "Suggested Hospitals",
            });
        });

        hospitalOptions = [...suggestedOptions];

        return [...suggestedOptions];
    };

    const onProviderChange = async () => {
        errInputs = removeErrorInput("doctorProviderSelect", errInputs);

        const selectedProvider = commonDetails.selectedDoctorProvider;

        if (!selectedProvider?.id) return;

        const selectedProviderHospitalsArr = selectedProvider.hospitals.map(
            (hospital) => hospital.hospitalId,
        );

        if (!selectedProviderHospitalsArr.length) return;

        const firstProviderHospitalId = selectedProviderHospitalsArr[0];

        let potentialHospital = await apiMethods.getMethod.getHospitalById(
            firstProviderHospitalId,
        );

        if (!potentialHospital?.id || commonDetails.selectedHospital?.id) return;

        commonDetails.selectedHospital = { ...potentialHospital };
    };

    const clearSelectedDoctorProvider = () => {
        commonDetails.selectedDoctorProvider = null;
    };

    const clearSelectedPreOpQuestionnaire = () => {
        commonDetails.selectedPreOpQuestionnaire = null;
    };

    const clearSelectedPreOpInstruction = () => {
        commonDetails.selectedPreOpInstruction = null;
    };

    const clearSelectedDoctor = () => {
        commonDetails.selectedDoctor = null;
        commonDetails.selectedDoctorProvider = null;
    };

    const loadDoctors = async (filterText) => {
        if(isAdmin){
             //for admin, load accounts from db
             await cacheAccountPrePopulateSearchOptions();

            if (!filterText)
                return $prePopulateAccountOptions.length
                    ? $prePopulateAccountOptions
                    : [];

            return $prePopulateAccountOptions.length
                ? $prePopulateAccountOptions.filter(({ value }) =>
                    value.toLowerCase().includes(filterText.toLowerCase()),
                )
                : [];
        } else {
            commonDetails.selectedDoctor = {
                ...$loggedInDoctorDetail
            }
            selectedDoctorProvidersOptions = $loggedInDoctorDetail.providers;
            //set selected doctor provider if there is only one option
            commonDetails.selectedDoctorProvider = selectedDoctorProvidersOptions.find((p) => p.isDefault) ?? null;

            return [];
        }
           
    };

    let selectedDoctorProvidersOptions = [];

    const onDoctorChange = async () => {
        errInputs = removeErrorInput(
            "doctorSelect",
            errInputs,
            "Doctor",
        );
        //reset surgeon selection
        commonDetails.selectedSurgeon = null;
        commonDetails.selectedDoctorProvider = null;
        commonDetails.selectedPreOpInstruction = null;
        commonDetails.selectedPreOpQuestionnaire = null;
        suggestedAccountDoctors = [];
        accountDoctors = [];
        preOpQuestionnaireOptions = [];
        preOpInstructionOptions = [];

        //set doctor providers
        isLoadingDoctorDetails = true;
        var doctorDetails = await apiMethods.getMethod.getAccountById(commonDetails.selectedDoctor.id);
        isLoadingDoctorDetails = false;
        if(!doctorDetails.error){
            var doctorProviders = doctorDetails.providers;
            commonDetails.selectedDoctorProvider = doctorProviders.find((p) => p.isDefault) ?? null;
            selectedDoctorProvidersOptions = doctorProviders;

            await onProviderChange();

            await loadPreOpInstructions();

            await loadPreOpQuestionnaires();
        }

        if(onDoctorChangeCallback)
            onDoctorChangeCallback();
    }

    const openCreateNewSurgeonModal = () => {
        if(commonDetails.selectedDoctor)
            isCreateNewSurgeonModalOpen = true;
        else {
            errInputs = addErrorInput("doctorSelect", errInputs, "Doctor");
        }

    }
    const closeCreateNewSurgeonModal = () =>
        (isCreateNewSurgeonModalOpen = false);

</script>

<CardLayout title="Common encounters details" enableCollapse={false} {btnOptions}>
    <div class="flex flex-1 flex-col gap-y-4 p-4">
        <div class="flex flex-1 justify-start gap-y-2 gap-x-2 col-span-1 xl:pr-3">
            <div class="flex flex-1 min-w-0 items-center">
                <p class="title">Doctor:</p>
                <div class="flex flex-1 w-remaining rounded-md" id="doctorSelect">
                    <Select
                        bind:value={commonDetails.selectedDoctor}
                        class="flex flex-1 max-h-[35px] rounded-full"
                        loadOptions={loadDoctors}
                        disabled={!isAdmin}
                        itemId="id"
                        label="fullName"
                        on:clear={clearSelectedDoctor}
                        on:select={onDoctorChange}
                        noOptionsMessage="No doctor found"
                        placeholder="Select doctor"
                        --placeholder-color="#9CA3AF"
                        --height="32px"
                        --value-container-padding="0"
                        --padding="0 0 0 12px"
                        --font-size="14px"
                    />
                </div>  
            </div>
            <div class="flex flex-1 min-w-0 items-center">
                <p class="title">Doctor provider:</p>
                <div class="flex flex-1 w-remaining  rounded-md" id="doctorProviderSelect">
                    <Select
                        bind:value={commonDetails.selectedDoctorProvider}
                        class="flex flex-1 max-h-[35px] rounded-full"
                        items={selectedDoctorProvidersOptions}
                        itemId="id"
                        disabled={commonDetails.selectedDoctor == null || isLoadingDoctorDetails}
                        label="number"
                        on:clear={clearSelectedDoctorProvider}
                        on:select={onProviderChange}
                        noOptionsMessage="No doctor provider found"
                        placeholder="Doctor provider"
                        --placeholder-color="#9CA3AF"
                        --height="32px"
                        --value-container-padding="0"
                        --padding="0 0 0 12px"
                        --font-size="14px"
                    />
                </div>
            </div>
            <div class="flex flex-1 min-w-0 items-center">
                <p class="title">Operating date:</p>
                <div  class="flex flex-1 w-full w-remaining">
                    <DateInput
                        bind:value={commonDetails.scheduledDate}
                        placeholder="Encounters Schedule Date"
                        id="scheduledDateField"
                        wrapperClass="input input-sm px-0 input-bordered w-full"
                        wrapperClassFocus="inputFocus"
                    />
                </div>
            </div>
        </div>
        <div class="flex flex-1 items-start justify-start gap-y-2 gap-x-2 col-span-1 xl:pr-3">
            <div class="flex flex-1 min-w-0">
                <div class="flex-1 flex flex-col items-start">
                    <p class="title flex-1 flex items-center">Surgeon / Referrer:</p> 
                    <p class="title flex-1"/>
                </div>
                <div class="flex flex-col items-start w-remaining rounded-md" >
                    <div class="flex w-full items-center rounded-md" id="surgeonSelect">
                        <Select
                            bind:value={commonDetails.selectedSurgeon}
                            class="flex flex-1 max-h-[35px] rounded-full"
                            items={surgeonOptions}
                            itemId="matchingId"
                            label="displayLabel"
                            groupBy={(option) => option.groupName}
                            on:clear={clearCurrentSurgeon}
                            on:focus={onFocusSurgeonSelector}
                            noOptionsMessage="No surgeon/referrer found"
                            placeholder="Surgeon/Referrer"
                            disabled={commonDetails.selectedDoctor == null || isLoadingDoctorDetails}
                            --placeholder-color="#9CA3AF"
                            --height="32px"
                            --value-container-padding="0"
                            --padding="0 0 0 12px"
                            --font-size="14px"
                        />
                    </div>
                    <div class="flex w-full items-center">
                        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <p
                            class="underline cursor-pointer text-secondary"
                            on:click={openCreateNewSurgeonModal}
                        >
                            Add new surgeon/referrer
                        </p>
                    </div>
                </div>
            </div>
            <div class="flex flex-1 min-w-0 items-center">
                <p class="title">Hospital:</p>

                <div class="w-remaining rounded-md" id="hospitalSelect">
                    <Select
                        bind:value={commonDetails.selectedHospital}
                        class="flex flex-1 max-h-[35px] rounded-full"
                        loadOptions={loadHospitals}
                        items={hospitalOptions}
                        groupBy={(option) => option.groupName}
                        itemId="id"
                        label="name"
                        on:clear={clearCurrentHospital}
                        on:select={handleHospitalChange}
                        on:focus={onFocusHospitalSelector}
                        noOptionsMessage="No hospital found"
                        placeholder="Hospital"
                        --placeholder-color="#9CA3AF"
                        --height="32px"
                        --value-container-padding="0"
                        --padding="0 0 0 12px"
                        --font-size="14px"
                    />
                </div>
            </div>
            <div class="flex min-w-0 flex-1 items-center">
                <p class="title">Encounter Type:</p>
                <select
                    class="select flex-1 select-bordered select-sm"
                    bind:value={commonDetails.typeOfBill}
                >
                    {#each encounterBillingType as billingType}
                        <option value={billingType.id}>
                            {billingType.type}
                        </option>
                    {/each}
                </select>
            </div>
        </div>
        <div class="flex flex-1 justify-start gap-y-2 gap-x-2 col-span-1 xl:pr-3">
            <!-- PreOp Questionnaire-->
            <div class="flex-1 flex flex-row items-center">
                <p class="title">PreOp Questionnaire:</p>
                   <Select
                        bind:value={commonDetails.selectedPreOpQuestionnaire}
                        id="preopQuestionnaireSelect"
                        class="flex flex-1 max-h-[35px] rounded-full"
                        items={preOpQuestionnaireOptions}
                        itemId="id"
                        disabled={commonDetails.selectedDoctor == null || isLoadingDoctorDetails}
                        label="name"
                        on:clear={clearSelectedPreOpQuestionnaire}
                        noOptionsMessage="No Pre Op Questionnaire found"
                        placeholder="PreOp Questionnaire"
                        --placeholder-color="#9CA3AF"
                        --height="32px"
                        --value-container-padding="0"
                        --padding="0 0 0 12px"
                        --font-size="14px"
                    />
                  
                    {#if commonDetails.selectedPreOpQuestionnaire && preOpQuestionnaireOptions.length}
                        <button
                            class="btn btn-ghost btn-sm ml-2"
                            on:click|preventDefault={goToPreviewQuestionnaire}
                        >
                            Preview
                        </button>
                    {/if}
            </div>
            <!-- PreOp Instructions -->
            <div class="flex-1 flex flex-row items-center">
                <p class="title">PreOp Instructions:</p>
                 <Select
                    bind:value={commonDetails.selectedPreOpInstruction}
                    id="preopInstructionSelect"
                    class="flex flex-1 max-h-[35px] rounded-full"
                    items={preOpInstructionOptions}
                    itemId="id"
                    disabled={commonDetails.selectedDoctor == null || isLoadingDoctorDetails}
                    label="name"
                    on:clear={clearSelectedPreOpInstruction}
                    noOptionsMessage="No Pre Op Instructions found"
                    placeholder="PreOp Instructions"
                    --placeholder-color="#9CA3AF"
                    --height="32px"
                    --value-container-padding="0"
                    --padding="0 0 0 12px"
                    --font-size="14px"
                />
            </div>
        </div>
    </div>
</CardLayout>

<CreateSurgeonModal
    {isCreateNewSurgeonModalOpen}
    reloadSurgeonDetails={() => loadAccountDoctors(false)}
    closeFunc={closeCreateNewSurgeonModal}
    bind:filters={createSurgeonFilters}
    bind:selectedSurgeon={commonDetails.selectedSurgeon}
    doctorId={commonDetails.selectedDoctor?.id}
    existedOptions={surgeonOptions}
/>

<style>
    .title {
        width: 170px;
    }

    .w-remaining {
        width: calc(100% - 170px);
    }
</style>


